// AddDealerModel.js

import React, { useState, useContext } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { UserContext } from "../contexts/UserContext";
import { addDealerMember } from "../services/UserServices";
import { showDefaultAlert } from "../utils/Alerts";
import { FormControl, TextField } from "@mui/material";

const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export default function AddDealerModel({ open, handleClose, setNewDealer }) {
  const { user, token } = useContext(UserContext);
  const [email, setEmail] = useState("");
  const [emailErrorMessage, setEmailErrorMessage] = useState("");

  const addDealer = async (e) => {
    e.preventDefault();
    try {
      if (!email) {
        setEmailErrorMessage("Email is required");
        return;
      }
      if (!emailRegex.test(email)) {
        setEmailErrorMessage("Invalid email address");
        return;
      }
      handleClose();
      const response = await addDealerMember(email, user.DealerID, user.UserID, token);
      setNewDealer(response.data);
      if (response.status === 200) {
        showDefaultAlert("success", "Success", `Successfully Added New User ${email}.`);
        setEmail("");
      }
    } catch (error) {
      handleClose();
      if (error.response && error.response.status === 400) {
        if (error.response.data === "This dealer member already exists.") {
          showDefaultAlert("error", "Error", "This dealer member already exists.");
        } else if (error.response.data === "This member belongs to another dealer company.") {
          showDefaultAlert("error", "Error", "This member belongs to another dealer company.");
        }
      } else {
        showDefaultAlert("error", "Error", "An error occurred. Please try again later.");
      }
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <Box
          sx={{
            bgcolor: "white",
            boxShadow: 24,
            p: { xs: 3, sm: 4 },
            borderRadius: "8px",
            width: { xs: "90vw", sm: 360 },
            maxWidth: 420,
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <div className="form-group">
            <form onSubmit={addDealer}>
              <FormControl fullWidth>
                <TextField
                  label="Email"
                  variant="outlined"
                  fullWidth
                  required
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailErrorMessage("");
                  }}
                />
              </FormControl>
              <p style={{ color: "red", margin: "0" }}>{emailErrorMessage}</p>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: "space-between",
                  gap: 2,
                  marginTop: "16px",
                }}
              >
                <Button
                  onClick={handleClose}
                  variant="outlined"
                  color="primary"
                  sx={{ width: { xs: "100%", sm: "40%" } }}
                >
                  Close
                </Button>
                <Button
                  className="btn"
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{ width: { xs: "100%", sm: "40%" } }}
                >
                  Submit
                </Button>
              </Box>
            </form>
          </div>
        </Box>
      </Box>
    </Modal>
  );
}
